<template>
    <div class="cst-survey-title-bar">
        <div class="cst-survey-nav-container nav-left" v-if="has_previous_card && !is_finished">
            <a @click="card_prev" class="nav nav-left">
                <arrow-left></arrow-left>
            </a>
        </div>
        <h1 v-html="title"></h1>
        <div class="cst-survey-nav-container nav-right" v-if="has_next_card">
            <a @click="card_next" class="nav nav-right">
                <arrow-right></arrow-right>
            </a>
        </div>
    </div>
</template>

<script>
    /* global eventHub */
    /* eslint no-undef: "error" */
    import ArrowLeft from './ArrowLeft'
    import ArrowRight from './ArrowRight'

    export default {
      props: ['card_next', 'card_prev', 'has_next_card', 'has_previous_card', 'is_finished'],
      data: function () {
        return {
          title: 'TITLE IN NAVBAR'
        }
      },
      methods: {
        set_title: function (title) {
          this.title = title
        }
      },
      created: function () {
        eventHub.$on('set-title', this.set_title)
      },
      components: {
        ArrowLeft, ArrowRight
      }
    }
</script>

<style lang="less" scoped>
    @import '../_theme';

    .cst-survey-title-bar {
        display: flex;
        justify-content: space-between;
        margin-top: 1em;
    }
    a.nav {
        width: 100%;
        margin: 1%;
        height: 1.5em;
        text-align: right;
        cursor: pointer;
    }
    a.nav-left {
        text-align: left;
        margin-left: 0.3em;
    }
    a.nav-right {
        margin-right: 0.3em;
    }    
    a.nav * {
        height: 1.5em;
    }

    .cst-survey-nav-container {
        width: 4em;
        padding: 1%;
        padding-top: 2%;
        display: flex;
        height: 1.5em;
        align-items: center;
    }
    .cst-survey-nav-container.nav-left {
        margin-right: -1em;
    }
    .cst-survey-nav-container.nav-right {
        margin-left: -1em;
    }
    @media (min-width: 800px) {
        .cst-survey-title-bar {
            justify-content: center;
        }
    }
    h1 {
        margin: 0 1em;
    }

    @media (max-width: 500px) {
      h1 {
        font-size: 100%;
      }
    }
</style>

<style>
    h1 br {
        display: none;
    }
</style>


// WEBPACK FOOTER //
// src/components/AppNavBar.vue